<template>
  <div class="bg-dashboard screen-list">
    <!-- filter customer -->
    <div class="on-top-header-dashboard">
      <div class="card-nav">
        <v-autocomplete
          v-model="modelSearch"
          :items="dataCustomers"
          :loading="isLoading"
          :search-input.sync="search"
          hide-details
          hide-selected
          item-text="customer_name"
          item-value="customer_id"
          rounded
          placeholder="Start typing to filter..."
        >
          <template v-slot:selection="{ attr, on, item, selected }">
            <v-chip
              v-bind="attr"
              :input-value="selected"
              color="blue-grey"
              class="white--text"
              v-on="on"
            >
              <img :src="item.customer_pic" class="profile-user" />
              <span v-text="item.customer_name" style="color: black"></span>
            </v-chip>
          </template>
          <template v-slot:item="{ item }">
            <img :src="item.customer_pic" class="profile-user" />
            <v-list-item-content>
              <v-list-item-title
                v-text="item.customer_name"
              ></v-list-item-title>
            </v-list-item-content>
          </template>
        </v-autocomplete>
      </div>
    </div>

    <!-- filter กรองตาม -->
    <div class="card-filter">
      <div class="content filter d-flex">
        <label class="f-20">กรองตาม :</label>

        <v-chip-group class="filter-slide">
          <button
            v-for="(items, index) in dataTags"
            :key="index"
            type="button"
            class="btn-filter textoverflow"
            :class="{ active: tagsID == items.id }"
            @click="filterTags(items.id)"
          >
            {{ items.name }}
          </button>
        </v-chip-group>
      </div>
    </div>

    <div class="card-list">
      <div>
        <h4>รายการบันทึก</h4>
        <small>{{ total }} รายการ</small>
      </div>
      <div class="dropdown-tpye">
        <label for="ประเภท">ประเภท :</label>
        <select v-model="modelType" class="form-control">
          <option value="">ทั้งหมด</option>
          <option value="0">NOTE</option>
          <option value="1">VOC</option>
        </select>
      </div>
    </div>

    <TheBlogPost
      v-if="dataNoteList != ''"
      :datas="dataNoteList"
      @remove="actionsNoteVoc"
      @edit="actionNoteVocEdit"
    />

    <TheBlogEmpty v-else />

    <ScrollLoader
      v-show="!loadMore"
      :loader-method="getNoteList"
      :loader-enable="loadMore"
    />

    <TheFooterAdd
      :tags="dataTags"
      :customerID="modelSearch"
      @save="actionsNoteVoc"
      :mode="modeNote"
      :listCustomer="listCustomer"
    />
  </div>
</template>

<script>
import TheBlogPost from '@/components/v2/TheBlogPost.vue'
import TheFooterAdd from '@/components/v2/TheFooterAdd.vue'
import TheBlogEmpty from '@/components/v2/TheBlogEmpty.vue'
import { mapState, mapActions } from 'vuex'
export default {
  components: {
    TheBlogPost,
    TheFooterAdd,
    TheBlogEmpty,
  },

  data() {
    return {
      isLoading: false,
      search: ``,
      tab: null,
      dataCustomers: [],
      dataTags: [],
      modelType: '',
      modelSearch:
        this.$store.getters['checkinout/getIsVisiting'] == null
          ? 'ทั้งหมด'
          : this.$store.getters['checkinout/getIsVisiting'].customer_id,
      page: 1,
      total: 0,
      total_pages: 0,
      limit: 5,
      tagsID: '',
      dataNoteList: [],
      loadMore: false,
      modeNote: '',
      listCustomer: [],
    }
  },

  watch: {
    modelType() {
      this.activeLoadmore()
    },

    customerID() {
      this.resetParameter()

      setTimeout(() => {
        this.getNoteList()
      }, 500)
    },
  },

  computed: {
    ...mapState({
      user: (state) => state.auth.user,
    }),

    customerID() {
      return this.modelSearch == 'ทั้งหมด' ? '' : this.modelSearch
    },
  },

  methods: {
    ...mapActions({
      visitCustomers: 'checkinout/visitCustomers',
    }),

    async getTags() {
      try {
        const { data } = await this.axios.get(
          `${this.$baseAPINew}/mobile/?act=tag_voc_list`,
        )
        this.dataTags = data.items
      } catch (error) {
        console.error(error)
      }
    },

    getCustomer() {
      const options = {
        url: `${this.$baseAPINew}/web/?act=list_customer`,
        method: 'POST',
        data: { user_id: this.user.id },
      }
      this.$axios(options).then((res) => {
        for (const i in res.data) {
          this.dataCustomers.push({
            customer_name: res.data[i].customer_name,
            customer_pic: res.data[i].customer_pic,
            customer_id: res.data[i].customer_id,
            user_id: res.data[i].user_id,
            shop_id: res.data[i].shop_id,
          })
        }
        this.dataCustomers.unshift({
          customer_name: 'ทั้งหมด',
          customer_pic: require('../../public/img/icons_v2/default_shop.png'),
          customer_id: 'ทั้งหมด',
          user_id: ``,
          shop_id: ``,
        })
        this.listCustomer = res.data
      })
    },

    getNoteList() {
      const formData = {
        user_id: this.user.id,
        customer_id: this.customerID,
        note_voc: this.modelType,
        page: this.page,
        limit: this.limit,
        tag_id: this.tagsID,
      }
      const options = {
        url: `${this.$baseAPINew}/mobile/?act=note_list`,
        method: 'POST',
        data: formData,
      }
      this.$axios(options).then((res) => {
        this.total = res.data.total == undefined ? 0 : res.data.total
        this.total_pages =
          res.data.total_pages == undefined ? 0 : res.data.total_pages

        this.loadMore = this.page >= this.total_pages

        res.data.items &&
          (this.dataNoteList = [...this.dataNoteList, ...res.data.items])
        this.page++
      })
    },

    filterTags(id) {
      this.tagsID = this.tagsID == id ? '' : id
      this.activeLoadmore()
    },

    activeLoadmore() {
      this.page = 1
      this.total = 0
      this.total_pages = 0
      this.dataNoteList = []
      if (this.loadMore) {
        this.getNoteList()
      }
    },

    resetParameter() {
      this.page = 1
      this.total = 0
      this.total_pages = 0
      this.tagsID = ''
      this.dataNoteList = []
    },

    actionsNoteVoc() {
      this.resetParameter()

      setTimeout(() => {
        this.getNoteList()
      }, 500)
    },

    actionNoteVocEdit(data) {
      this.modeNote = { mode: 'edit', item: data }
    },
  },

  mounted() {
    this.$nextTick(function () {
      this.$store.dispatch('setTitle', 'บันทึกโน๊ต')
    })

    // set background
    const wrap = document.querySelectorAll('.v-application--wrap')
    wrap[0].style.backgroundColor = '#eef3fa'

    this.visitCustomers({ user_id: this.user.id })

    this.getTags()
    this.getCustomer()
  },
}
</script>

<style scoped lang="scss">
// *,
// h4,
// small,
// label,
// select {
//   font-size: 20px !important;
// }

// icon
.icon-arch1 {
  padding: 7px;
  border-radius: 50%;
  background: #fff3f4;
}
.icon-NOTE {
  padding: 3px;
  border-radius: 50%;
  background: #f5f5f7;
  &::before {
    color: #aeaeae;
  }
}

* {
  font-family: Prompt;
}

h4 {
  color: #000;
  font-weight: 600;
  font-size: 18px;
}

small {
  font-size: 16px;
  color: #585c60;
}

.screen-list {
  width: 100%;
}

.card-nav {
  background-color: white;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 81px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
  margin-top: 10px;
}

.card-filter {
  background: #f9f9f9;
  margin-top: 1px;
  border-bottom: 1px solid #cdd8e6;

  & label {
    display: flex;
    align-items: center;
    margin: 0;
    padding-right: 10px;
  }
}

.card-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 30px;
}

.content {
  margin: 0px 30px;

  &.blog {
    padding: 23px 0px;
  }

  &.user {
    padding: 10px 0px;
    display: flex;
    justify-content: space-between;
  }

  &.filter {
    padding: 16px 0px;
    margin-right: 10px;
  }
}

.profile-user {
  border-radius: 50%;
  height: 50px;
  width: 50px;
  margin-right: 14px;
}

.dropdown-tpye {
  display: flex;

  & label {
    display: flex;
    margin: 11px;
  }
  & select {
    width: 156px;
    height: 46px;
    border-radius: 9px;
    border: solid 1px #979797;
    padding: 10px 22px;
  }
}

.filter-slide {
  width: 85%;
}

// button
.btn-tag {
  background: #4a90e2;
  border-radius: 4px;
  color: #ffffff;
  width: auto;
  height: 28px;
  font-size: 14px;
  display: flex;
  justify-items: center;
  align-items: center;
  padding: 10px;
}
.btn-filter {
  width: auto;
  height: auto;
  margin: 0 5px;
  border-radius: 9px;
  border: solid 1px #cacaca;
  background-color: #eaeaea;
  padding: 10px;
  outline: none;
  &.active {
    background: #ff811c;
    color: white;
    outline: none;
  }
  &:focus {
    outline: none;
  }
}

@media screen and (max-width: 600px) {
  .dropdown-tpye select {
    width: 100px !important;
  }

  .filter-slide {
    width: 220px !important;
  }

  .card-nav {
    margin-top: 20px;
  }
}

.theme--light.v-chip:not(.v-chip--active) {
  background: none !important;
}

.v-application .blue-grey {
  background-color: none !important;
  border-color: none !important;
}

.v-application .white--text {
  color: #171717 !important;
}

.v-text-field--rounded > .v-input__control > .v-input__slot {
  padding: 0px !important;
}

.v-list-item--link {
  padding: 10px 20px !important;
}
.v-list-item__title {
  font-size: 20px !important;
}

.theme--light.v-chip:not(.v-chip--active) {
  height: 100% !important;
}
</style>
